export const formatCheckboxGroupValue = (value: Array<string | number>) => {
    if (value.length) {
        return value.toString().split(',');
    }

    return [];
};
